export const MainURL = {
  // HostUrl: "http://68.178.165.241:1992/api",
  HostUrl: "http://97.74.89.186:1992/api",
  // HostUrl: "http://localhost:1992/api",
};
